import {
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  Link,
  makeStyles,
  Typography,
} from "@material-ui/core";
import RoomIcon from "@material-ui/icons/Room";
import CustomTooltip from "components/CustomTooltip";
import SanitizedGrid from "components/SanitizedGrid";
import { useState } from "react";
import { Button, SimpleForm } from "react-admin";
import AddressAutoCompleteInput from "./AddressAutoCompleteInput";
import SaveChangeLocationButton from "./SaveChangeLocationButton";

interface IChangePickupLocationButton {
  routeLocationData: any;
  changeLocationCallback: any;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
      width: "100%",
    },
  },
  closeTextWrapper: {
    float: "right",
    margin: "7px 4px 0 0",
    cursor: "pointer",
  },
  closeText: {
    color: "#474747",
    fontWeight: 600,
    textDecoration: "underline",
  },
  changeLocationStudentTooltip: {
    marginTop: "-15px",
  },
  changeLocationStudentButton: {
    padding: "5px",
    marginLeft: "5px",
    minWidth: "10px",
    backgroundColor: "#787373",
    boxShadow: "0 4px 8px rgb(120 115 115 / 30%)",
    "& .MuiButton-textSizeSmall": {
      padding: 0,
    },
    "& .MuiButton-label > .MuiSvgIcon-root": {
      fontSize: 20,
    },
    "&:hover": {
      backgroundColor: "#787373 !important",
    },
  },
});

const ChangePickupLocationButton = ({
  routeLocationData,
  changeLocationCallback,
}: IChangePickupLocationButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <CustomTooltip
        title="Change pickup location"
        aria-label="Change pickup location"
        classes={{
          tooltip: classes.changeLocationStudentTooltip,
        }}
      >
        <Button
          className={classes.changeLocationStudentButton}
          onClick={handleOpenDialog}
        >
          <RoomIcon />
        </Button>
      </CustomTooltip>
      <Dialog
        open={open}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className={classes.dialog}
        maxWidth="xs"
      >
        <DialogTitle id="alert-dialog-title">
          Change Location
          <Link
            aria-label="close"
            className={classes.closeTextWrapper}
            onClick={handleClose}
          >
            <Typography variant="body2" className={classes.closeText}>
              Cancel
            </Typography>
          </Link>
        </DialogTitle>
        <DialogContent>
          <Typography variant="subtitle2">
            Current:{" "}
            {`${routeLocationData.blockNumber} ${routeLocationData.street}, ${routeLocationData.postalCode}`}
          </Typography>
          <SimpleForm toolbar={null}>
            <SanitizedGrid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="subtitle2">Select new location</Typography>
              </Grid>
              <Grid item xs={12}>
                <AddressAutoCompleteInput
                  label="Select Address"
                  source="address"
                  referenceSource="locationData"
                />
              </Grid>

              <Grid item xs={12}>
                <SaveChangeLocationButton
                  handleClose={handleClose}
                  routeLocationData={routeLocationData}
                  changeLocationCallback={(value: any, oldPostalCode: string) =>
                    changeLocationCallback(value, oldPostalCode)
                  }
                />
              </Grid>
            </SanitizedGrid>
          </SimpleForm>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ChangePickupLocationButton;
